import React from 'react';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Menu from '@material-ui/core/Menu/Menu';
import { enLang } from 'interfaces/IProductData';
import { langService } from 'services/LangService';
import Avatar from '@material-ui/core/Avatar/Avatar';
import { SvgIcon } from 'components/SvgIcon';
import LangItem from './LangItem';

const styles = require('./configCountry.css');

interface IState extends IStateBase {
  anchorEl: any;
  options: { lang: enLang, text: string }[];
  lang: string;
}

export default class ConfigCountry extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      anchorEl: null,
      options: [
        { lang: enLang.PT_BR, text: 'Brasil - R$ BRL' },
        { lang: enLang.EN_US, text: 'Internacional - US$ USD' }
      ],
      lang: null
    };
  }

  componentDidMount() {
    this.observeState({ lang: null }, langService.getLang());
  }

  close = () => {
    this.setState({ anchorEl: null });
  }

  open = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  selectLang = (lang: enLang) => {
    langService.setLang(lang);
    this.close();
  }

  render() {

    const { anchorEl, options, lang } = this.state;

    if (!lang) {
      return <div />;
    }

    const selectedLang = options.find(o => o.lang == lang);

    return (
      <div
        className={`chk-config-country ${!this.props.circle ? '' : 'chk-configCountry___avatar'} ${styles.component}`}
        id='chk-config-country'
      >
        {this.props.circle ?
          <div className={'classes.row'}>
            <Avatar
              id='chk-selectlang-circle-button'
              onClick={this.open}
              alt={selectedLang.text}
              className={'classes.avatar'}
            >
              <SvgIcon name={`flag_${selectedLang.lang}_round`} />
            </Avatar>
          </div>
          :
          <a
            id={`chk-selectlang-button-${lang}`}
            className='chk-config-button'
            onClick={this.open}
          >
            <SvgIcon name={`flag_${selectedLang.lang}`} />
            <span className='chk-option-active theme-language-bar-selected'>{selectedLang.text}</span>
          </a>
        }

        <Menu
          id='lock-menu'
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.close}
        >
          {options.map((option) => (
            <LangItem
              key={option.lang}
              selected={lang === option.lang}
              option={option}
              onSelect={this.selectLang}
            />
          ))}
        </Menu>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/ConfigCountry/index.tsx